module.exports = __webpack_public_path__ + "static/media/3.72cdacd7.png";